import axios from "axios";
import api from '../api';
import { getTokens, setTokens } from '../utils/helpers/auth';

const getNewAccessToken = async () => {
  const { refreshToken } = getTokens();
  if (!refreshToken) {
    return false;
  }

  const response = await api.auth.refreshTokens(refreshToken);
  const { accessToken } = setTokens(response);
  return accessToken;
};

axios.interceptors.request.use(
  async (config) => {
    const { accessToken } = getTokens();
    
    if (accessToken) {
      const tokenData = accessToken.split('.')[1];
      const decodedToken = JSON.parse(atob(tokenData));
      const expiry = new Date(decodedToken.exp * 1000);

      // Check if token is expired
      if (expiry > new Date()) {
        config.headers.Authorization = `Bearer ${accessToken}`;
      } else {
        const newAccessToken = await getNewAccessToken();
        if (!newAccessToken) {
          return config;
        }

        config.headers.Authorization = `Bearer ${newAccessToken}`;
      }
    } else {
      const newAccessToken = await getNewAccessToken();
      if (!newAccessToken) {
        return config;
      }

      config.headers.Authorization = `Bearer ${newAccessToken}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
